import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AlertTriangle, Clock } from "lucide-react";
import apiClient from "../lib/api";

const TIER_STYLES = {
  blue: {
    wrapper: "bg-blue-600 border-blue-700 text-white",
    icon: "text-blue-100",
    link: "text-white underline underline-offset-2 hover:text-blue-100",
  },
  yellow: {
    wrapper: "bg-amber-400 border-amber-500 text-amber-950",
    icon: "text-amber-900",
    link: "text-amber-950 underline underline-offset-2 hover:text-amber-900",
  },
  red: {
    wrapper: "bg-red-600 border-red-700 text-white",
    icon: "text-red-100",
    link: "text-white underline underline-offset-2 hover:text-red-100",
  },
};

const SubscriptionExpiryBanner = () => {
  const { t } = useTranslation("components");
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const res = await apiClient.get("/pharmacy/subscription-status");
        if (mounted && res.data?.banner?.show) {
          setBanner(res.data.banner);
        } else if (mounted) {
          setBanner(null);
        }
      } catch {
        if (mounted) setBanner(null);
      }
    };

    load();
    const interval = setInterval(load, 5 * 60 * 1000);
    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, []);

  if (!banner?.show || !banner.tier) return null;

  const styles = TIER_STYLES[banner.tier] || TIER_STYLES.blue;
  const Icon = banner.tier === "blue" ? Clock : AlertTriangle;

  return (
    <div
      className={`mb-6 rounded-xl border px-4 py-3 flex items-start gap-3 ${styles.wrapper}`}
      role="alert"
      data-testid={`subscription-banner-${banner.tier}`}
    >
      <Icon className={`h-5 w-5 mt-0.5 flex-shrink-0 ${styles.icon}`} />
      <div className="flex-1 text-sm font-medium">
        <p>{banner.message}</p>
        <Link to="/dashboard/subscription" className={`text-xs mt-1 inline-block ${styles.link}`}>
          {t("subscriptionRenew")}
        </Link>
      </div>
    </div>
  );
};

export default SubscriptionExpiryBanner;
